<p>{{ message }}</p>
<ul>
  <li *ngFor="let item of listItems">{{ item }}</li>
</ul>
